import { render, staticRenderFns } from "./bookNow.vue?vue&type=template&id=04c97d1c&"
import script from "./bookNow.vue?vue&type=script&lang=js&"
export * from "./bookNow.vue?vue&type=script&lang=js&"
import style0 from "./bookNow.vue?vue&type=style&index=0&id=04c97d1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports